(ns frontend.ui.page.fund.investor-references.model
  (:require
   [common.endpoints.updates.fund-commitment-investors :as contract]))

(def root-path [:views :fund-investor-references])

(defn state
  [db owner-id]
  (get-in db (conj root-path owner-id)))

(defn configuration
  [{:keys [fund-id commitment-ids]}]
  {:fund-id fund-id
   :commitment-ids (->> commitment-ids distinct sort vec)})

(defn scopes
  [{:keys [owner-id generation fund-id commitment-ids]}]
  (->> commitment-ids
       (partition-all contract/batch-size)
       (map-indexed
        (fn [batch-id ids]
          {:owner-id owner-id
           :generation generation
           :batch-id batch-id
           :entity-id fund-id
           :instance-id (str "fund-investors-" owner-id "-" generation "-" batch-id)
           :scope {:profile contract/profile
                   :commitment-ids (vec ids)}}))
       vec))

(defn active?
  [db {:keys [owner-id generation batch-id]}]
  (let [current (state db owner-id)]
    (and (some? generation)
         (= generation (:generation current))
         (contains? (:batches current) batch-id))))

(defn status
  [db owner-id]
  (let [batches (vals (:batches (state db owner-id)))]
    {:loading? (boolean (some :loading? batches))
     :error (some :error batches)}))
